import { mutatorAction } from 'satcheljs';
import { getActivityFeedStore } from '../store/store';

export const toggleActivityFeedSettingPage = mutatorAction(
    'TOGGLE_ACTIVITY_FEED_SETTING_PAGE',
    (isActivityFeedSettingOpen: boolean) => {
        getActivityFeedStore().isActivityFeedSettingOpen = isActivityFeedSettingOpen;
    }
);
